import React from 'react';
import ActionLoading from 'app/components/ActionLoading';
import { Popup, Button as SemanticButton, Dropdown } from 'semantic-ui-react';
import Button from 'components/Button/Button';
import BrowserIcon from 'components/Icons/BrowserIcon';
import BloomIcon from 'components/Icons/BloomIcon';
import ToolsIcon from 'components/Icons/ToolsIcon';
import WorkspaceIcon from 'components/Icons/WorkspaceIcon';
import { extendLoading, createLoading, terminateLoading } from '../constants';
import { hasExpired, getLaunchUrl, getBloomLaunchUrl, getNeulerLaunchUrl, getNeodashLaunchUrl, getToolsLaunchUrl, getWorkspaceLaunchUrl } from '../helper';
import GoogleSheetUseCaseButton from './GoogleSheetUseCaseButton/GoogleSheetUseCaseButton';
import NeulerImg from 'app/assets/images/neuler.png';
import NeodashImg from 'app/assets/images/neodash.png';
var handleTracking = function (type, usecase) {
    window.neo4jSandbox.tracking.event('SANDBOX_LAUNCH', {
        usecase: usecase,
        type: type,
    });
};
var options = function (data, accessToken, onBloomLaunch, onNeulerLaunch, onNeodashLaunch, onToolsLaunch, onWorkspaceLaunch) { return [
    {
        key: 'browser',
        text: 'Open with Browser',
        as: 'a',
        href: getLaunchUrl(data, accessToken),
        target: '_blank',
        onClick: function () {
            handleTracking('browser-from-dropdown', data.usecase);
        },
        icon: {
            children: function () { return (React.createElement("i", { style: { marginRight: 8 } },
                React.createElement(BrowserIcon, null))); },
        },
    },
    {
        key: 'bloom',
        text: 'Open with Bloom',
        as: 'a',
        href: getBloomLaunchUrl(data),
        target: '_blank',
        onClick: function (e) {
            e.preventDefault();
            handleTracking('bloom', data.usecase);
            onBloomLaunch(data);
        },
        icon: {
            children: function () { return (React.createElement("i", { style: { marginRight: 8 } },
                React.createElement(BloomIcon, null))); },
        },
    },
    {
        key: 'neuler',
        text: 'Open with NEuler',
        as: 'a',
        href: getNeulerLaunchUrl(data),
        target: '_blank',
        onClick: function (e) {
            e.preventDefault();
            handleTracking('neuler', data.usecase);
            onNeulerLaunch(data);
        },
        icon: {
            children: function () { return (React.createElement("i", { style: { marginRight: 8 } },
                React.createElement("img", { alt: "neuler", src: NeulerImg, width: "16px" }))); },
        },
    },
    {
        key: 'tools',
        text: 'Open with Tools',
        as: 'a',
        href: getToolsLaunchUrl(data),
        target: '_blank',
        onClick: function (e) {
            e.preventDefault();
            handleTracking('tools', data.usecase);
            onToolsLaunch(data);
        },
        icon: {
            children: function () { return (React.createElement("i", { style: { marginRight: 8 } },
                React.createElement(ToolsIcon, null))); }
        }
    },
    {
        key: 'workspace',
        text: 'Open with Workspace',
        as: 'a',
        href: getWorkspaceLaunchUrl(data),
        target: '_blank',
        onClick: function (e) {
            e.preventDefault();
            handleTracking('workspace', data.usecase);
            onWorkspaceLaunch(data);
        },
        icon: {
            children: function () { return (React.createElement("i", { style: { marginRight: 8 } },
                React.createElement(WorkspaceIcon, null))); }
        }
    },
    {
        key: 'neodash',
        text: 'Open with NeoDash',
        as: 'a',
        href: getNeodashLaunchUrl(data),
        target: '_blank',
        onClick: function (e) {
            e.preventDefault();
            handleTracking('neodash', data.usecase);
            onNeodashLaunch(data);
        },
        icon: {
            children: function () { return (React.createElement("i", { style: { marginRight: 8 } },
                React.createElement("img", { alt: "neodash", src: NeodashImg, width: "16px" }))); },
        },
    },
]; };
export var ActionColumn = function (_a) {
    var data = _a.data, isTerminating = _a.isTerminating, isExtending = _a.isExtending, accessToken = _a.accessToken, onBloomLaunch = _a.onBloomLaunch, onNeulerLaunch = _a.onNeulerLaunch, onNeodashLaunch = _a.onNeodashLaunch, onToolsLaunch = _a.onToolsLaunch, onWorkspaceLaunch = _a.onWorkspaceLaunch;
    if (isTerminating) {
        return React.createElement(ActionLoading, { data: terminateLoading, color: "pink", size: "small" });
    }
    if (isExtending) {
        return React.createElement(ActionLoading, { data: extendLoading, size: "small", color: "blue" });
    }
    if (data.status === 'PENDING') {
        return React.createElement(ActionLoading, { data: createLoading, size: "small", color: "blue" });
    }
    if (data.usecase === 'gsheets') {
        return React.createElement(GoogleSheetUseCaseButton, { data: data, accessToken: accessToken });
    }
    if (hasExpired(data.expires))
        return null;
    return (React.createElement(SemanticButton.Group, { color: "blue", size: "small" },
        React.createElement(Popup, { trigger: React.createElement(Button, { primary: true, href: getLaunchUrl(data, accessToken), target: "_blank", as: "a", className: "launch-action-btn font-regular", size: "small", onClick: function () { return handleTracking('browser', data.usecase); } }, "Open"), content: "Open with Browser", inverted: true }),
        React.createElement(Dropdown, { className: "button icon", floating: true, options: options(data, accessToken, onBloomLaunch, onNeulerLaunch, onNeodashLaunch, onToolsLaunch, onWorkspaceLaunch), trigger: React.createElement(React.Fragment, null) })));
};
export default ActionColumn;
